import axios from "axios";
import { ClientClassificationType } from "models/client_classification_type";
import {
  OrcamentoDepto,
  OrcamentoDeptoCategoria, OrcamentoDeptoItem
} from "models/orcamento_departamento";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";
import usePaymentForm from "views/admin/finance/paymentForm/hooks/usePaymentForm";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import useProductOrder from "views/admin/order/product/hooks/useProductOrder";

const useDeptoOrcamento = () => {
  const [list, setList] = useState<OrcamentoDepto[]>([]);
  const [itens, setItens] = useState<OrcamentoDeptoCategoria[]>([]);

  const [deptoList, setAccountTypeList] = useState<ClientClassificationType[]>(
    []
  );
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<OrcamentoDepto>(null);
  const [users, setUsers] = useState<UsuarioModel[]>([]);
  const [selectedUser, setSelectedUser] = useState<UsuarioModel>();
  const cancelRef = useRef();
  const { unidades } = useMeasureUnit();
  const { produtos } = useProductOrder();
  const { condicaoPagamentos } = usePaymentForm();
  const [showItem, setShowItem] = useState(false);
  const nomeRef = useRef(null);
  const [enableDrag, setEnableDrag] = useState(true);

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      cleanInput();
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcament-departamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setList(response.data);
    }
  };

  const loadDepto = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/departamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  };

  const validateField = (condition: any, errorMessage: string) => {
    if (!condition) {
      showError("Erro!", errorMessage);
      return false;
    }
    return true;
  };

  const validate = () => {
    let response = true;

    response =
      validateField(
        accountSelected?.departamentoId,
        "Selecione o Depto para criar o Orçamento"
      ) && response;

      response =
      validateField(
        accountSelected?.vigencia,
        "Selecione a vigência"
      ) && response;

      response =
      validateField(
        accountSelected?.descricao,
        "Preencha Corretamente a vigência"
      ) && response;


      response =
      validateField(
        selectedUser,
        "Selecione o usuário responsável"
      ) && response;

    response =
      validateField(
        itens?.length > 0,
        "Você deve inserir itens no orçamento"
      ) && response;
    return response;
  };

  const add = () => {
    showModal(true);
  };

  const cleanInput = () => {
    setItens([]);
    setAccountSelected(null);
    setSelectedUser(null);
  };

  const save = async () => {
    if (validate()) {
      setLoading(true);
      if (accountSelected?.id === undefined) {
        await addRegister();
      } else {
        await updateRegister();
      }
      setLoading(false);
      showModal(false);
      cleanInput();
      await loadData();
    }

  };

  const addRegister = async () => {
    const obj = {
      alocado: 0,
      departamentoId: accountSelected.departamentoId,
      disponivel: 0,
      idEmpresa: usuario?.idEmpresa,
      total: itens.reduce ((value, acc) => Number(acc.valor) + value, 0),
      verba: 0,
      descricao : accountSelected?.descricao,
      vigencia: accountSelected?.vigencia,
      usuarioId: selectedUser.id,
      
    };
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/orcament-departamento/",
      obj
    );
    if (response.data) {
      const item: OrcamentoDepto = response.data;
      for (let index = 0; index < itens.length; index++) {
        const element = itens[index];
        const newitem : OrcamentoDeptoCategoria = {
          ...element,
          orcamentoDeptoId: item.id,     
        };

       const categResponse =  await axios.post(
          process.env.REACT_APP_API_URL + "/orcament-departamento/category/",
          newitem
        );
        if(categResponse) {
          const categoria :  OrcamentoDeptoCategoria = categResponse.data;
          for (let index = 0; index < element.OrcamentoDeptoItem.length; index++) {
            const servico = element.OrcamentoDeptoItem[index];

            const newServico : OrcamentoDeptoItem ={
              ...servico,
              orcamentoDeptoCategoriaId: categoria.id
            }
             await axios.post(
              process.env.REACT_APP_API_URL + "/orcament-departamento/item/",
              newServico
            );
          }

        }
      }
    }
  };

  const updateRegister = async () => {


    const obj = {
      alocado: 0,
      departamentoId: accountSelected.departamentoId,
      disponivel: 0,
      idEmpresa: usuario?.idEmpresa,
      total: itens.reduce((value, acc) => Number(acc.valor) + value, 0),
      verba: 0,
      descricao : accountSelected?.descricao,
      vigencia: accountSelected?.vigencia,
      usuarioId: selectedUser.id,
      id: accountSelected?.id,
    };

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/orcament-departamento/" + accountSelected.id,
      obj
    );

    if (response.data === true) {

      
        if(accountSelected?.OrcamentoDeptoCategoria.length > 0) {
          for (let index = 0; index < accountSelected?.OrcamentoDeptoCategoria?.length; index++) {
            const el = accountSelected?.OrcamentoDeptoCategoria[index];
            await axios.delete(
              process.env.REACT_APP_API_URL + "/orcament-departamento/categpry/" + el.id
            );
        }
      }
      for (let index = 0; index < itens.length; index++) {
        const element = itens[index];
        const newitem : OrcamentoDeptoCategoria = {
          ...element,
          orcamentoDeptoId: accountSelected.id,     
        };

       const categResponse =  await axios.post(
          process.env.REACT_APP_API_URL + "/orcament-departamento/category/",
          newitem
        );
        if(categResponse) {
          const categoria :  OrcamentoDeptoCategoria = categResponse.data;
          for (let index = 0; index < element.OrcamentoDeptoItem.length; index++) {
            const servico = element.OrcamentoDeptoItem[index];

            const newServico : OrcamentoDeptoItem ={
              ...servico,
              orcamentoDeptoCategoriaId: categoria.id
            }
             await axios.post(
              process.env.REACT_APP_API_URL + "/orcament-departamento/item/",
              newServico
            );
          }

        }
      }
    }

    };

  const edit = async (item: OrcamentoDepto) => {
    showModal(true);
    setAccountSelected(item);
    changeUser(item?.usuarioId);

    const newItens: OrcamentoDeptoCategoria[] = [];

    if (item.OrcamentoDeptoCategoria.length > 0) {
      item.OrcamentoDeptoCategoria.forEach((valor) => {
        const dt: OrcamentoDeptoItem[] = [];
        if (valor?.OrcamentoDeptoItem?.length > 0) {
          valor.OrcamentoDeptoItem.forEach((oi) => {
            const add: OrcamentoDeptoItem = {
              descricao: oi.descricao,
              id: oi.id,
              nivel: oi.nivel,
              orcamentoDeptoCategoriaId: valor.id,
              valorTotal: oi.valorTotal,
            };
            dt.push(add);
          });
        }

        const cat: OrcamentoDeptoCategoria = {
          descricao: valor.descricao,
          orcamentoDeptoId: valor.orcamentoDeptoId,
          valor: valor.valor,
          id: valor.id,
          ordem: valor.ordem,
          OrcamentoDeptoItem: dt,
        };
        newItens.push(cat);
      });
      setItens(newItens);;
    }
    
  };

  const showDeleteModal = (item: OrcamentoDepto) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletar = async () => {
    await axios.delete(
      process.env.REACT_APP_API_URL + "/orcament-departamento/" + accountSelected?.id
    );

    setLoading((prev) => (prev = false));
    showModal(false);
    setAccountSelected(null);
    setShowDelete(false);
    await loadData();
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const closeError = () => {
    setError(false);
  };

  const changeInput = (value: any, type: string) => {
    switch (type) {
      case "depto":
        setAccountSelected({ ...accountSelected, departamentoId: value });
      break;
      case "vigencia":
        setAccountSelected({ ...accountSelected, vigencia: value });
      break;
      case "usuarioId":
        setAccountSelected({ ...accountSelected, usuarioId: value });
      break;
      case "descricao":
        setAccountSelected({ ...accountSelected, descricao: value });
      break;
    }
  };
  const loadUsers = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/user/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setUsers(response.data);
    }
  };

  const changeUser = (item: string) => {
    const selected = users?.find((f) => f.id === item);
    if (selected) {
      setSelectedUser(selected);
    }
  };  


  const showItemModal = (show: boolean) => {
    setShowItem(show);
  };

  const changeItem = (item: OrcamentoDeptoCategoria) => {
    const newItems: OrcamentoDeptoCategoria[] = itens.map(
      (existingItem) => {
        if (existingItem.descricao === item.descricao) {
          return item;
        }
        return existingItem;
      }
    );

    newItems.map((value) => {
      let itemTotal = 0;
      if(value?.OrcamentoDeptoItem?.length > 0){
         itemTotal =  value?.OrcamentoDeptoItem?.reduce((acc, vl) => acc + Number(vl.valorTotal), 0)
      }
      value.valor =  itemTotal;
    })

    setItens(newItems);

  };

  const removeItem = (item: OrcamentoDeptoCategoria) => {
    let total = 0;
    const list = itens;
    const data = list.filter((data) => data !== item);
    data.forEach((item) => {
      total = total + item.valor;
    });

    setItens(data);
  };

  const saveCategory = (ordem : number) => {
    if (nomeRef.current.value !== null) {
      const categArray = itens;

      const add: OrcamentoDeptoCategoria = {
        descricao: nomeRef.current,
        OrcamentoDeptoItem: [],
        orcamentoDeptoId: "",
        valor: 0.0,
        ordem: ordem,
        id: "",
      };
      const exists = categArray.find(
        (value) => value.descricao === add.descricao
      );
      if (!exists) {
        categArray.push(add);
        setShowItem(false);
      }
    }
  };

  const isDragable = (drag: boolean) => {
    setEnableDrag(drag);
  };

  const reorder = (
    list: OrcamentoDeptoCategoria[],
    startIndex: number,
    endIndex: number
  ) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    setItens(result);
  };


  useEffect(() => {
    const initialize = async () => {
      await Promise.all([loadData(), loadDepto(), loadUsers()]);
    };
    initialize();
  }, []);

  return {
    accountSelected,
    add,
    list,
    changeInput,
    closeError,
    showError,
    deletar,
    closeDelete,
    showDeleteModal,
    edit,
    save,
    showModal,
    cancelRef,
    showDelete,
    error,
    errorMsg,
    errorTitle,
    show,
    loading,
    usuario,
    deptoList,
    users,
    selectedUser,
    changeUser,
    unidades,
    produtos,
    condicaoPagamentos,
    showItem,
    showItemModal,
    nomeRef,
    enableDrag,
    removeItem,
    reorder,
    isDragable,
    saveCategory,
    changeItem,
    itens
  };
};
export default useDeptoOrcamento;
